import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

import js from '../../static/images/js-logo.png';
import py from '../../static/images/py-logo.png';
import bs from '../../static/images/bs-logo.png';
import css from '../../static/images/css-logo.png';
import html from '../../static/images/html-logo.png';
import mui from '../../static/images/mui-logo.png';
import cs from '../../static/images/csharp-logo.png';
import ai from '../../static/images/ai-logo.png';
import as from '../../static/images/aspen-logo.png';
import bl from '../../static/images/blender-logo.png';
import exjs from '../../static/images/expressjs-logo.png';
import fb from '../../static/images/fb-logo.png';
import jq from '../../static/images/jquery-logo.png';
import ms from '../../static/images/ms-logo.png';
import ps from '../../static/images/ps-logo.png';
import rjs from '../../static/images/react-logo.png';
import sar from '../../static/images/sar-logo.png';
import wp from '../../static/images/wp-logo.png';
import bg from '../../static/images/bg.jpg';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper
    },
    bg: {
        position: "relative",
        backgroundImage: "linear-gradient(rgba(245, 222, 179, 0.3), rgba(76, 142, 203, 0.6)), url(" + bg + ")",
        backgroundAttachment: "fixed"
    },
    gridList: {
        minHeight: 150,
    },
    grid1: {
        minHeight: "80vh"
    },
    grid: {
        minHeight: "100vh"
    },
    st0: { 
        fill: "white"
    },
    st1: {
        opacity:"0.8",
        fill:"#F5DEB3"
    },
    
}));

const toolData = [
    {
        img: ai,
        title: "Adobe Illustrator Logo"
    },
    {
        img: as,
        title: "ASPEN Plus Logo"
    },
    {
        img: bl,
        title: "Blender Logo"
    },
    {
        img: ms,
        title: "Microsoft Office Logo"
    },
    {
        img: ps,
        title: "Adobe Photoshop Logo"
    },
    {
        img: sar,
        title: "Spark AR Logo"
    }
]

const tileData = [
    {
        img: js,
        title: 'JavaScript Logo',
        cols: 1,
    },
    {
        img: py,
        title: "Python Logo",
        cols: 1
    },
    {
        img: bs,
        title: "BootStrap Logo",
        cols: 1
    },
    {
        img: css,
        title: 'CSS3 Logo',
        cols: 1,
    },
    {
        img: mui,
        title: "Material UI Logo",
        cols: 1
    },
    {
        img: html,
        title: "HTML Logo",
        cols: 1
    },
    {
        img: cs,
        title: "CSharp Logo",
        cols: 1
    },
    {
        img: exjs,
        title: "ExpressJS Logo"
    },
    {
        img: fb,
        title: "Firebase Logo"
    },
    {
        img: jq,
        title: "jQuery Logo"
    },
    {
        img: rjs,
        title: "React Logo"
    },
    {
        img: wp,
        title: "WordPress Logo"
    }
];

export default function Skills() {
    const classes = useStyles();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("sm"));
    const sz = () => {
        if(matches) {
            return 6;
        }

        return 3;
    }

    return (
        <>
            <CssBaseline />
            <Container className={classes.root} id="scroll-to-top-anchor">
                <Grid container justify="center" alignContent="center" className={classes.grid1}>
                    <Grid item xs={12} sm={6}>
                        <Grid 
                        container 
                        justify="center"
                        >
                            <Grid item>
                                <Typography variant="h3" gutterBottom style={{color:"#4c8ecb"}}>
                                    <Box className={`${"wow bounceInUp"}`} fontWeight="bold" mb={3}>
                                        Skills
                                    </Box>
                                </Typography>
                            </Grid>
                        </Grid>
                        <GridList cellHeight={75} spacing={6} cols={sz()} className={`${classes.gridList} ${"wow bounceInUp"}`} style={{animationDelay: "0.3s", WebkitAnimationDelay: "0.3s", MozAnimationDelay: "0.3s"}}>
                            {tileData.map((tile) => (
                                <GridListTile key={tile.img} style={{ overflow: "auto" }} cols={1}>
                                    <img src={tile.img} alt={tile.title} />
                                </GridListTile>
                            ))}
                        </GridList>
                    </Grid>
                </Grid>
            </Container>
            <Container className={`${classes.root} ${classes.bg}`}>
            <svg version="1.1" id="Layer_2" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        viewBox="0 0 1920 1080" style={{ position: "absolute", top: "-30", left: "0" }} xmlSpace="preserve">
                        <path className={classes.st1} d="M827,82c252.19-173.32,315,37,570,95c117.97,26.83,201.43-69.9,342-71c128-1,181-106,181-106L0,0
	c0,0,0,218-1,256C80,6,345,284,555,138C671.19,57.22,737.32,143.63,827,82z"/>
                    </svg>
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        viewBox="0 0 1920 1080" style={{ position: "absolute", top: "-1", left: "0" }} xmlSpace="preserve">
                        <path className={classes.st0} d="M1921,0c0,0-196,61-310,47c-155.51-19.1-164,107-564.44-26.46c-41.99-14-87.89-10.43-129.59,4.42
	C690.85,105.46,620.92,26.61,540,45c-67.12,15.25-114.24,92.31-247.14,92.31C110.36,137.31,23,147,0.5,211V0L1921,0z"/>
                    </svg>         
                <Grid container justify="center" alignItems="center" className={classes.grid}>
                    <Grid item xs={12} sm={6}>
                        <Grid container justify="center">
                            <Grid item>
                                <Typography variant="h3" gutterBottom style={{color: "#fff"}}>
                                <Box className={`${"wow bounceInUp"}`} fontWeight="bold" mb={3}>
                                        Tools
                                    </Box>
                                </Typography>
                            </Grid>
                        </Grid>
                        <GridList cellHeight={150} spacing={6} className={`${classes.gridList} ${"wow bounceInUp"}`} style={{animationDelay: "0.3s", WebkitAnimationDelay: "0.3s", MozAnimationDelay: "0.3s"}} cols={3}>
                            {toolData.map((tile) => (
                                <GridListTile key={tile.img} style={{ overflow: "auto" }} cols={tile.cols || 1}>
                                    <img src={tile.img} alt={tile.title} style={{ height: "50%" }} />
                                </GridListTile>
                            ))}
                        </GridList>
                    </Grid>
                </Grid>
            </Container>
        </>
    )
}